class RequestPasswordRequestDto {
  email!: string;
}

export default RequestPasswordRequestDto;
